export default __webpack_public_path__ + "static/media/rocket_anim_17.a83544ad.png";